import React from 'react';
import { StarIcon, TimerIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { BuyButton } from './ui/BuyButton';
interface HeroProps {
  countdown: {
    hours: string;
    minutes: string;
    seconds: string;
  };
}
export function Hero({
  countdown
}: HeroProps) {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-63" data-mp="4m8kg77n0hia">
      {/* Top Banners */}
      <div className="bg-sage-800 py-2.5 text-center" data-id="element-64" data-mp="12a0n3gpgsax9">
        <p className="px-4 text-[11px] font-bold uppercase tracking-overline text-gold-200" data-id="element-65" data-mp="128pg780q2n1x">
          100% DIGITAL - INSTANT DOWNLOAD
        </p>
      </div>
      <div className="bg-terracotta-500 py-2 text-center" data-id="element-66" data-mp="sai16upzuf2k">
        <p className="flex items-center justify-center gap-2 px-4 text-[12px] font-semibold uppercase tracking-wider text-cream" data-id="element-67" data-mp="sd48ct8z2sk9">
          <TimerIcon className="h-4 w-4" data-id="element-68" data-mp="3d1sdb54ebxwt" />
          Limited time offer:{' '}
          <span className="font-bold" data-id="element-69" data-mp="382p6bf4uvhm7">
            {countdown.minutes}:{countdown.seconds} MINUTES LEFT
          </span>
        </p>
      </div>

      <div className="mx-auto max-w-4xl px-5 pb-16 pt-10 text-center sm:px-8 lg:pb-24 lg:pt-16" data-id="element-70" data-mp="3j9tzsvxzjik8">
        <p className="inline-flex items-center justify-center gap-2 rounded-full border border-gold-200/60 bg-bone px-4 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.2em] text-terracotta-600" data-id="element-71" data-mp="3o6aqnxwkkb10">
          PRESS · PRESERVE · CREATE · SELL
        </p>

        <h1 className="mt-8 font-serif text-[2.7rem] leading-[1.05] text-sage-900 sm:text-[4rem] lg:text-[4.5rem]" style={{
        fontWeight: "700"
      }} data-id="element-72" data-mp="30iaziwvciilw">
          Turn real flowers into beautiful pieces you can{' '}
          <span className="italic text-terracotta-500" data-id="element-73" data-mp="2qkdc2blb8puc">create, gift</span> and sell.
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] leading-relaxed text-ink-soft sm:text-[18px]" data-id="element-74" data-mp="2viev4wiqkp5t">
          Learn step by step how to press, preserve and turn flowers into framed art,
          cards and delicate botanical keepsakes — without losing their color or
          natural beauty.
        </p>

        <div className="mx-auto mt-8 flex w-fit max-w-full flex-col items-center gap-2 rounded-3xl border border-gold-200/50 bg-cream px-5 py-3 shadow-sm sm:flex-row sm:gap-3 sm:rounded-full sm:py-2.5" data-id="element-75" data-mp="s2b9g2qj4r79">
          <div className="flex items-center gap-3" data-id="element-76" data-mp="ibgod1p0rxne">
          <div className="flex -space-x-2" data-id="element-77" data-mp="ia5fingpvzpf">
            <img src={testimonials[0].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-78" data-mp="ddwy13f1ruf3" />
            <img src={testimonials[1].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-79" data-mp="1622irq63pjex" />
            <img src={testimonials[2].avatar} alt="" className="h-7 w-7 rounded-full border-2 border-cream object-cover" data-id="element-80" data-mp="114kispa2aej2" />
          </div>
          <div className="flex items-center gap-0.5" data-id="element-81" data-mp="3lqudvm65c340">
            {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" data-id="element-82" data-mp="3htpzbveggqo1" data-mpi={i} />)}
          </div>
          </div>
          <p className="text-center text-[12px] font-medium leading-snug text-sage-800 sm:text-left" data-id="element-83" data-mp="21b629t7jkskj">
            <span className="font-semibold" data-id="element-84" data-mp="268oblkph19t2">4.9 / 5</span>
            <span className="hidden sm:inline" data-id="element-85" data-mp="2b0zhr5at1ru2"> · </span>
            <span className="block sm:inline" data-id="element-86" data-mp="2b2kbwtt7j8re">
              2,400+ women have pressed their first flower
            </span>
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-[320px] sm:max-w-[380px]" data-id="element-87" data-mp="2kxu8h20u6nxs">
          <video src="https://cdn.magicpatterns.com/uploads/thrKpiMxnHnpqAGzz78u9J/WhatsApp Video 2026-08-29 at 23.17.47.mp4" autoPlay loop muted playsInline className="aspect-[9/16] w-full rounded-[2rem] object-cover shadow-[0_30px_60px_-15px_rgba(56,52,44,0.3)]" data-id="element-88" data-mp="2ozz426auhun2" />
        </div>

        <div className="mt-12 flex flex-col items-center gap-3" data-id="element-89" data-mp="znn8ug06uj11">
          <BuyButton size="xl" label="Get Pressed Flower Studio" href="#oferta" data-id="element-90" data-mp="4a2u7jchl7z3" />
          <p className="text-[12.5px] font-medium text-ink-light" data-id="element-91" data-mp="3vigoe8dy4hzd">
            Digital guide · instant access
          </p>
        </div>
      </div>
    </header>;
}